import { render, staticRenderFns } from "./TemplateMaster.vue?vue&type=template&id=4d42b4a0&"
import script from "./TemplateMaster.vue?vue&type=script&lang=js&"
export * from "./TemplateMaster.vue?vue&type=script&lang=js&"
import style0 from "./TemplateMaster.vue?vue&type=style&index=0&id=4d42b4a0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports